<!--
  - Copyright (c) 2018 BarD Software s.r.o
  -->

<template>
    <div class="project-remove-modal modal fade" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="d-flex align-items-center">
                        <i class="fa fa-exclamation-circle fa-3x"></i>
                        <p class="m-0 ml-2">This will delete project <b>{{project ? project.name : ""}}</b></p>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary btn-cancel" data-dismiss="modal" tabindex="1">Cancel</button>
                    <button type="button" class="btn btn-danger" v-on:click="remove" tabindex="2">Yes, delete</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" src="./ProjectRemoveModal.ts"></script>
